import React, { Component, Fragment, useRef } from "react";

import "./Comment.css";

function Comment(props) {
    let { comment, onClick } = props;
    let { message, replies, poster, time, id } = comment;
    const selectCbRef = useRef(null);

    // const onClick = (id, checkbox, message) => {
    //     props.onClick(id, checkbox, message);
    // };

    return (
        <div className="CommentComponent">
            <div className="CommentContainer">
                <div className="message">
                    <input
                        type="checkbox"
                        className="select"
                        ref={selectCbRef}
                        onClick={(ev) => {
                            onClick(comment.id, ev.target, message);
                        }}
                    />
                    <div className="sender">{poster.name}</div>
                    <div className="time">{`(${new Date(
                        parseInt(time)
                    ).toLocaleDateString()})`}</div>
                    :<div className="message">{message}</div>
                </div>

                {replies && replies.length > 0 && (
                    <div className="showReplies text info">
                        <input
                            type="checkbox"
                            className="showReplies"
                            defaultChecked={false}
                        />
                        <div className="caption">
                            <div className="not">عدم</div>
                            نمایش پاسخ ها
                            {`( ${replies.length} )`}
                        </div>
                    </div>
                )}
                {replies && (
                    <div className="replies">
                        {replies.length > 0 &&
                            replies.length > 0 &&
                            replies.map((reply) => {
                                return (
                                    <Comment
                                        comment={reply}
                                        key={reply.id}
                                        onClick={onClick}
                                    />
                                );
                            })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Comment;
